import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Lingua } from '@/i18n';
import type { MarchioId } from './marchi';

export type Unita = 'C' | 'F';
export type Tema = 'scuro' | 'chiaro';

interface Preferenze {
  lingua: Lingua;
  unita: Unita;
  tema: Tema;
  marchio: MarchioId | null;
  impiantoPerMarchio: Partial<Record<MarchioId, string>>;
  setLingua(l: Lingua): void;
  setUnita(u: Unita): void;
  setTema(t: Tema): void;
  setMarchio(m: MarchioId): void;
  setImpianto(marchio: MarchioId, impiantoId: string): void;
}

export const usePreferenze = create<Preferenze>()(
  persist(
    (set) => ({
      lingua: 'it',
      unita: 'C',
      tema: 'scuro',
      marchio: null,
      impiantoPerMarchio: {},
      setLingua: (lingua) => set({ lingua }),
      setUnita: (unita) => set({ unita }),
      setTema: (tema) => set({ tema }),
      setMarchio: (marchio) => set({ marchio }),
      setImpianto: (marchio, impiantoId) => set((s) => ({ impiantoPerMarchio: { ...s.impiantoPerMarchio, [marchio]: impiantoId } })),
    }),
    // Rinominata con il prodotto (era `emaenergy.preferenze`): le preferenze
    // già salvate sui dispositivi esistenti tornano ai valori predefiniti.
    // Accettabile: l'app è stata pubblica per un solo pomeriggio ed è ora
    // dietro una holding page, quindi non esiste di fatto stato da migrare.
    { name: 'emacomfort.preferenze' },
  ),
);
